import isEmpty from '../../../Shared/Utils/isEmpty';

const ONE_SECOND_IN_MS = 1000;

const subscribeToPlaybackApiResponse = (
    playbackApiResponse$,
    concurrencyStore,
) =>
    playbackApiResponse$
        .subscribe(playbackResponse => {
            const playbackLock = playbackResponse && playbackResponse.playbackLock;
            if (isEmpty(playbackLock))  {
                return concurrencyStore.actions.disableFeature();
            }

            const {
                concurrencyServiceUrl,
                encryptedLock,
                lockId,
                playerId,
                sequenceToken,
                updateLockIntervalSeconds,
            } = playbackLock;

            concurrencyStore.actions.updateConcurrency({
                partialServiceUrl: concurrencyServiceUrl,
                encryptedLock,
                lockId,
                playerId,
                sequenceToken,
                updateIntervalMs: updateLockIntervalSeconds * ONE_SECOND_IN_MS,
                isEnabled: true,
            });
        });

export default subscribeToPlaybackApiResponse;
